import { imgixHost } from 'src/config'
import DeliveryLocation from 'src/models/delivery-location/DeliveryLocation'
import Model, { ID } from 'src/models/model'
import Archivable from 'src/models/model/concerns/Archivable'
import Librariable from 'src/models/model/concerns/Librariable'

export default class PagerRequestType extends Model {
  static name = 'PagerRequestType'

  static isConfiguration = true

  static deletable = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site]

  static define () {
    this.concerns = [Archivable, Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        default: null
      },
      displayName: {
        type: String,
        default: null,
        translatable: true
      },
      icon: {
        type: String,
        default: 'clean_hands'
      },
      iconImage: {
        type: String,
        default: null
      },
      iconImageParams: {
        type: String,
        default: 'w=128&h=128&fit=fill&fill=solid&auto=format',
        local: true
      },
      iconImagePreviewParams: {
        type: String,
        default: 'w=80&h=80&fit=fill&fill=solid&transparency=grid&auto=format',
        local: true
      },
      deliveryLocations: {
        type: [DeliveryLocation],
        default: () => { return [] },
        encode (data) {
          data.deliveryLocationIds = _.map(this.deliveryLocations.data, 'id')
        },
        reference: true
      },
      displayOrder: {
        type: Number,
        default: 100
      }
    }

    this.computed = {
      iconImageUrl () {
        if (!this.iconImage) return ''

        return `${imgixHost}/${this.iconImage}?${this.iconImageParams}`
      },
      iconImagePreviewUrl () {
        if (!this.iconImage) return ''

        return `${imgixHost}/${this.iconImage}?${this.iconImagePreviewParams}`
      }
    }

    this.paginate = true
  }
}
